module.exports = __webpack_public_path__ + "img/note-2.bfec1223.svg";